"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProcessRequestObForResp = exports.ProcessHeaderWithAuthType = exports.AuthHeaderObservable = exports.AuthType = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const dataRetrive_1 = require("../dataRetrive");
const Error_1 = require("../error/Error");
const Tools_1 = require("./Tools");
var AuthType;
(function (AuthType) {
    AuthType["None"] = "None";
    /** 账户token */
    AuthType["Access"] = "Access";
    /** 现货token */
    AuthType["Spot"] = "Spot";
    AuthType["AccessAndSpot"] = "AccessAndSpot";
    AuthType["AccessAndTrader"] = "AccessAndTrader";
    AuthType["FullToken"] = "FullToken";
})(AuthType || (exports.AuthType = AuthType = {}));
const AuthHeaderObservable = (tokenTypes, headers, withBearer = true) => {
    if (tokenTypes.length === 1 && tokenTypes[0] === "access") {
        return (0, dataRetrive_1.getTradeDependencyInstance)()
            .getAccessToken()
            .pipe((0, operators_1.map)((token) => {
            let Authorization = `${withBearer ? "Bearer " : ""}${token}`;
            return Object.assign(Object.assign({}, headers), { Authorization });
        }));
    }
    return (0, dataRetrive_1.getTradeDependencyInstance)()
        .getTradingToken()
        .pipe((0, operators_1.map)((res) => {
        if (!res) {
            throw Error_1.ErrorGenerate.generateError(Tools_1.TradeHttpErrorCode.TradeUnAuthorized, "trade_unAuthorized");
        }
        return res;
    }), (0, operators_1.map)((tradingTokenInfo) => {
        let Authorization = withBearer ? "Bearer " : "";
        tokenTypes.forEach((type, index) => {
            if (index > 0) {
                Authorization += "|";
            }
            switch (type) {
                case "access": {
                    Authorization += tradingTokenInfo.awsToken || "";
                    break;
                }
                case "spot": {
                    Authorization += tradingTokenInfo.tradingToken || "";
                    break;
                }
                case "trader": {
                    Authorization += tradingTokenInfo.traderToken || "";
                    break;
                }
                case "swap_binance": {
                    Authorization += tradingTokenInfo.swapToken || "";
                    break;
                }
                default: {
                    break;
                }
            }
        });
        const authHeader = Object.assign(Object.assign({}, headers), { Authorization: Authorization });
        return authHeader;
    }));
};
exports.AuthHeaderObservable = AuthHeaderObservable;
/**
 * 根据authType处理成带token的header
 * @param headers 外部传入的header
 * @param authType 签名类型
 * @param withBearer 是否加bearer
 */
function ProcessHeaderWithAuthType(headers, authType = AuthType.None, withBearer = true) {
    let _headers = Object.assign({ "Content-Type": "application/json;charset=UTF-8" }, headers);
    switch (authType) {
        case AuthType.Access:
            return (0, exports.AuthHeaderObservable)(["access"], _headers, withBearer);
        case AuthType.Spot:
            return (0, exports.AuthHeaderObservable)(["spot"], _headers, withBearer);
        case AuthType.AccessAndSpot:
            return (0, exports.AuthHeaderObservable)(["access", "spot"], _headers, withBearer);
        case AuthType.AccessAndTrader:
            return (0, exports.AuthHeaderObservable)(["access", "trader"], _headers, withBearer);
        case AuthType.FullToken:
            return (0, exports.AuthHeaderObservable)(["access", "spot", "swap_binance", "trader"], _headers);
        default:
            return (0, rxjs_1.of)(_headers);
    }
}
exports.ProcessHeaderWithAuthType = ProcessHeaderWithAuthType;
function ProcessRequestObForResp(requestOb, needProcessResp = true) {
    if (needProcessResp) {
        return (0, Tools_1.resolveResponse)(requestOb);
    }
    else {
        return requestOb;
    }
}
exports.ProcessRequestObForResp = ProcessRequestObForResp;
